import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';

import type { ChangeEventHandler, FC } from 'react';

import './CertificatesFilters.scss';

interface CertificatesFiltersProps {
  searchTerm: string;
  onChangeSearchTerm: ChangeEventHandler<HTMLInputElement>;
  onSearch: () => void;
  onReset: () => void;
}

export const CertificatesFilters: FC<CertificatesFiltersProps> = ({
  searchTerm,
  onChangeSearchTerm,
  onSearch,
  onReset,
}) => (
  <div className="CertificatesFilters">
    <Input
      addonBefore={<SearchOutlined />}
      placeholder="Введите название сертификата"
      aria-label="Поиск по названию сертификата"
      value={searchTerm}
      onChange={onChangeSearchTerm}
      onPressEnter={onSearch}
      className="CertificatesFilters__search"
      data-testid="certificates-search"
    />
    <div className="CertificatesFilters__buttons">
      <Button
        icon={<CloseCircleOutlined />}
        onClick={onReset}
        className="CertificatesFilters__button"
        data-testid="certificates-reset"
      >
        Сброс
      </Button>
      <Button
        type="primary"
        onClick={onSearch}
        className="CertificatesFilters__button"
        data-testid="certificates-search-button"
      >
        Показать
      </Button>
    </div>
  </div>
);
